"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loadBodyScript = (url) => {
    return new Promise((resolve, reject) => {
        const el = document.getElementById("mercuryo-body");
        if (el) {
            resolve();
            return;
        }
        const script = document.createElement("script");
        script.id = "mercuryo-body";
        script.src = url;
        script.onerror = reject;
        document.body.appendChild(script);
    });
};
exports.default = loadBodyScript;
//# sourceMappingURL=helpers.js.map